import moment from "moment";
import { getAuthHeaders, getAuthHeadersForFormData } from "../auth";
import { GET_HOLIDAY_LIST_FOR_WEEK, GET_HOLIDAY_LIST,SAVE_HOLIDAYS, DELETE_HOLIDAY } from "../constants";

export const getHolidayListServiceConfig = (year) => {
    return {
        url: `${GET_HOLIDAY_LIST}?year=${year}`,
        options: {
            method: "GET",
            headers: getAuthHeaders()
        }
    }
}
export const deleteHolidayServiceConfig = (holidayId) =>{
      const payload = new FormData();
      payload.append('HolidayID',holidayId);
    return {
        url: DELETE_HOLIDAY,
        options: {
            method: "DELETE",
            headers: getAuthHeadersForFormData(),
            body:payload
        }
    }
}
export const saveHolidayServiceConfig = (holidayDetails) => {
    const { holidayId, holidayDate,holidayName,holidayDescription} = holidayDetails;
    const payload = {
        "HolidayID": holidayId || null,
        "HolidayName": holidayName,
        "HolidayDate": holidayDate,
        "Description": holidayDescription
    }
    return {
        url:SAVE_HOLIDAYS,
        options: {
            method: "POST",
            headers: getAuthHeaders(),
            body:JSON.stringify(payload)
        }
    }
}

export const getHolidaysListForCurrentWeekServiceConfig = ({ startDate, endDate }) => {
    const from = moment(startDate).format("YYYY-MM-DD");
    const to = moment(endDate).format("YYYY-MM-DD");
    return {
        url: `${GET_HOLIDAY_LIST_FOR_WEEK}?StartDate=${from}&EndDate=${to}`,
        options: {
            method: "GET",
            headers: getAuthHeaders()
        }
    }
}